//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio
// Creation Date : 11/02/2025
// Version : 1
// Description : pantalla de presion para reguladores
//------Changes -------------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Navbar from "../../Navbar";
import Notify from "../../Notify";
import { logEventos } from "../../../services/services";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import SupportIcon from "@mui/icons-material/Support";
import AddPresion from "./AddPresion";
import EditarPresion from "./EditarPresion";

function Reguladores_presion_eys() {
  const [presion, setPresion] = useState(); //p/tabla
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [datosPresion, setDatosPresion] = useState({});
  const globalTheme = useTheme();
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [obt, setObt] = useState(0);
  const [update, setUpdate] = useState(false);
  const [dialogAdd, setDialogAdd] = useState(false);
  const [dialogEditar, setDialogEditar] = useState(false);

  //    //acceso al menu
  useEffect(() => {
    logEventos(
      "Acceso al menú Presion Reguladores",
      "Presion Reguladores",
      "Agregar,editar,activar o desactivar una presion",
      localStorage.getItem("user")
    );
  }, []);
  //*************************************************************************************************************************************/
  const obtenerPresion = () => {
    fetch(UrlApi + "/reguladores_presion_eys")
      .then((data) => data.json())
      .then((data) => setPresion(data));
  };

  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerPresion();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true);
    setDialogAdd(true);
  };
  const handleCloseAdd = () => {
    setDialogAdd(false);
    setUpdate(true);
  };

  const mostrareditar = (datosDeLaLinea) => {
    setDialogEditar(true);
    setDatosPresion(datosDeLaLinea);
    //console.log("datos linea",datosDeLaLinea ? datosDeLaLinea : "NO");
  };
  const handleCloseEditar = () => {
    setDialogEditar(false);
    setUpdate(true);
  };

  useEffect(() => {
    if (update) {
      obtenerPresion();
      setUpdate(false);
    }
  }, [update]);

  const handleVolver = () => {
    setTabla(true);
  };

  // columnas tabla
  const columns = useMemo(
    () => [
      {
        header: "ID",
        accessorKey: "id_presion",
        size: 85,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Descripción",
        accessorKey: "descripcion_presion",
        size: 200,
        muiTableBodyCellProps: { align: "left" },
      },
    ],
    []
  );
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode, //let's use the same dark/light mode as the global theme
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)" //background in light mode
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem", //override to make tooltip font size larger
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };
  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  return (
    <div>
      <Navbar />
      <Container maxWidth="xl" mt={1} mb={2}>
        {presion && tabla ? (
          <Box mt={2} boxShadow={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                columns={columns}
                data={presion}
                initialState={initialState}
                positionActionsColumn="last"
                enableExpandAll={false}
                enableToolbarInternalActions={true}
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  // align: "left",
                })}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                renderTopToolbarCustomActions={() => (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevo}
                    >
                      Nueva Presión
                    </Button>
                    <Typography variant="poster" fontSize={26}>
                      <SupportIcon sx={{ size: 20 }} />
                      Presión de Reguladores
                    </Typography>
                  </>
                )}
                layoutMode="grid"
                localization={MRT_Localization_ES}
                enableColumnDragging={false} //No permite que se arrastren las columnas.
                enableEditing
                renderRowActions={(
                  { row } //las acciones del costado editar y ver
                ) => (
                  <div>
                    <Tooltip arrow placement="left" title="Editar Presión">
                      <IconButton
                        onClick={() => mostrareditar(row.original)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
              />
            </ThemeProvider>
            <br />
            <br />
          </Box>
        ) : null}

        {notificacion ? (
          <Notify
            mensaje={mensaje}
            open={openSnack}
            color={"#D4EFDF"}
            severity={"success"}
            handleClose={handleVolver}
          />
        ) : null}

        {dialogAdd ? (
          <AddPresion
            dialogAdd={dialogAdd}
            datos={datosPresion}
            actualizar={setObt}
            onClose={() => handleCloseAdd(false)}
            alta={setAlta}
            tabla={setTabla}
          ></AddPresion>
        ) : null}
        {dialogEditar ? (
          <EditarPresion
            dialogEditar={dialogEditar}
            datos={datosPresion}
            actualizar={setObt}
            onClose={() => handleCloseEditar(false)}
            editar={setEditar}
            tabla={setTabla}
          ></EditarPresion>
        ) : null}
      </Container>
    </div>
  );
}

export default Reguladores_presion_eys;
